import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback } from 'react';
import { SchedForm } from './SchedForm';

export const SchedDetail = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <SchedForm /> }];

  const augButtons = useCallback(
    (buttons) => {
      const status = entityObj.status;
      if (status !== 'ACTIVE' && status !== 'INACTIVE') {
        return;
      }
      const inactive = status === 'INACTIVE';
      buttons.push(
        <TitleButton
          key="schedStatusButton"
          dataTestId="sched-status-button"
          icon={inactive ? fas.faToggleOff : fas.faToggleOn}
          toolTip={inactive ? 'Activate' : 'Inactivate'}
          onClick={() =>
            rsrc.store(module, 'SCHED_STATUS_STORE_PLUGIN', {
              id: entityObj.id,
              status: inactive ? 'ACTIVE' : 'INACTIVE',
            })
          }
        />,
      );
    },
    [entityObj.status, entityObj.id, module, rsrc],
  );

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
